var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { attrs: { id: "purchase-sheet-layout" } },
    [
      this.contentLoaded
        ? _c("product-purchase-sheet", {
            attrs: {
              products: _vm.products,
              coursePage: _vm.coursePage,
              buttonLabel: _vm.buttonLabel,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("system-modal", { attrs: { content: _vm.systemModalContent } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }